import { PublicationFormValues } from './types';

/**
 * Paleta tomada del mockup (PublicationMookup.html) para mantener la identidad
 * visual del backoffice (rosa Ster + tonos de estado).
 */
export const FORM_COLORS = {
  pink: '#E8336A',
  pinkLight: '#fbeaf0',
  pinkMedium: '#f4c0d1',
  pinkDark: '#72243e',
  white: '#ffffff',
  bg: '#f8f7f6',
  border: 'rgba(0,0,0,0.1)',
  text: '#1a1a18',
  textSecondary: '#6b6a66',
  green: '#3b6d11',
  greenBg: '#eaf3de',
  greenBorder: '#c0dd97',
  amber: '#854f0b',
  amberBg: '#faeeda',
  amberBorder: '#fac775',
  red: '#a32d2d',
  redBg: '#fcebeb',
  redBorder: '#f7c1c1',
  blue: '#185fa5',
  blueBg: '#e6f1fb',
  blueBorder: '#b5d4f4',
  grayBg: '#f1efe8',
  gray: '#5f5e5a',
  grayBorder: '#d3d1c7',
};

export const FORM_STEPS = [
  'General',
  'Campaña',
  'Formas de pago',
  'Zona',
  'Stock y precios',
  'Variantes',
];

/**
 * Catálogos mock restantes. Campañas, productos, zonas y targets se cargan desde la API.
 */

export const CURRENCY_OPTIONS = [
  { id: 'ARS', name: '$ Pesos argentinos (ARS)' },
  { id: 'USD', name: 'USD Dólar (no disponible)', disabled: true },
];

export const STATUS_OPTIONS = [
  { id: 'activa', name: 'Activa' },
  { id: 'inactiva', name: 'Inactiva' },
];

export const PIPE_COMPANY_OPTIONS = [
  { id: '1', name: 'Novatech' },
  { id: '2', name: 'Leanval' },
  { id: '3', name: 'Athuel' },
];

export const PIPE_ORIGIN_OPTIONS = [
  { id: '1', name: 'Local' },
  { id: '2', name: 'TDF' },
  { id: '3', name: 'Internacional' },
];

/** Leanval (id 2) no admite origen Internacional (id 3). */
export const getPipeOriginOptions = (companyId: string) => {
  if (companyId === '2') {
    return PIPE_ORIGIN_OPTIONS.filter((option) => option.id !== '3');
  }
  return PIPE_ORIGIN_OPTIONS;
};

export const PIPE_COMPANY_NAME_TO_ID: Record<string, string> = {
  Novatech: '1',
  Leanval: '2',
  Athuel: '3',
};

export const getPipeCompanyName = (companyId?: number | string | null): string | undefined => {
  if (companyId == null || companyId === '') return undefined;
  return PIPE_COMPANY_OPTIONS.find((option) => option.id === String(companyId))?.name;
};

export const PIPE_ORIGIN_NAME_TO_ID: Record<string, string> = {
  Local: '1',
  TDF: '2',
  Internacional: '3',
};

export const SKELETON_OPTIONS = [
  { id: '', name: 'Sin asignar' },
  { id: '1', name: 'Posición 1' },
  { id: '2', name: 'Posición 2' },
  { id: '3', name: 'Posición 3' },
];

export const HIGHLIGHT_OPTIONS = [
  { id: 'default', name: 'Default' },
  { id: 'cuotas', name: 'Cuotas sin interés' },
  { id: 'unpago', name: '1 pago con descuento' },
];

export const MAIN_PRICE_OPTIONS = [
  { id: 'cuotas', name: 'Cuotas' },
  { id: 'unpago', name: '1 pago' },
];

export const AMOUNT_OPTIONS = [
  { id: 'base', name: 'Base (sin interés)' },
  { id: 'final', name: 'Final (con interés)' },
];

export const EMPTY_PUBLICATION_FORM: PublicationFormValues = {
  publicationId: '',
  productId: '',
  sku: '',
  productName: '',
  category: '',
  company: '',
  origin: '',
  currency: 'ARS',
  status: 'activa',
  relevance: '',
  pvpPrice: '',
  campaigns: [],
  targets: [],
  pvCampaignPrice: '',
  highlightMethod: 'default',
  oneePaymentCards: [],
  zones: [],
  skeletonPosition: '',
  stockQty: '',
  alarmBase: '',
  alarmMin: '',
  mainPrice: 'cuotas',
  mainAmount: 'base',
  alterPrice: 'unpago',
  alterAmount: 'base',
  variants: [],
};
